<template>
  <div>
    <div>
      <div class="sixteentosix sixteentosix-wrap omt-6 omt-md-25">
        <div class="new-background-wrap">
          <div
            class="kachelimage header-image zoom-image"
            style="
              background: url('/static/img/worldmap-2.jpg');
              background-position: top !important;
            "
          ></div>

          <div class="headline-wrap">
            <div class="headline">
              <div class="text-subtitle-2 text-md-h5">
                {{ $t("news_Letter_Management") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="mx-0 row align-items-start newsletter_management">
      <div class="col-xl-12 px-8">
        <div class="d-flex justify-between create_nl_title mb-5 pt-4">
          <h3>{{ $t("preview_Newsletter") }}</h3>
          <a
            :href="`/edit-news-letter?newsLetterId=${newsLetter.id}&lang=${this.$locale.toUpperCase()}`"
            class="back_btn"
          >
            <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}
          </a>
        </div>

        <div class="row disablerow justify-content-between align-items-start">
          <!-- Tabs -->
          <v-tabs
            v-model="languageTab"
            align-with-title
            touchless
            scrollable
            show-arrows
            class="LanguageselectTabgroup pt-md-4 pt-lg-0 pl-md-8 pl-4"
          >
            <v-tabs-slider color="indigo"></v-tabs-slider>

            <v-tab
              v-for="(language, i) in languageTabsNew"
              :key="language + i"
              class="LanguageselectTab"
              @click="getLanguuageCode(language.shortForm)"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    style="display: flex; align-items: center"
                  >
                    <img
                      style="width: 26px; height: 17px; vertical-align: unset"
                      :src="'/files/flags/' + language.flag"
                    />
                    &nbsp;&nbsp;
                    <span class="langauge-text-slider">
                      {{
                        language.shortForm === "KK"
                          ? "KZ"
                          : language.shortForm === "ZH" ||
                            language.shortForm === "CN"
                          ? "CN"
                          : $t(language.shortForm)
                      }}
                    </span>
                  </div>
                </template>
                <span>{{ $t(language.language) }}</span>
              </v-tooltip>
            </v-tab>
          </v-tabs>
          <div class="col-xl-9 newsletter_bg subject_line pnl">
            <div class="">
              <v-tabs-items v-model="languageTab" touchless>
                <v-tab-item
                  v-for="(language, i) in languageTabsNew"
                  :key="language + i"
                >
                  <div class="justify-content-between">
                    <!-- Put Content here -->

                    <!-- Tabs -->
                    <v-container class="pb-0">
                      <v-tabs
                        v-model="selectedTab"
                        align-with-title
                        class="tab_desktop_mobile"
                      >
                        <v-tab class="">
                          <div>
                            <img src="/static/img/desktop.svg" />
                            {{ $t("desktop") }}
                          </div>
                        </v-tab>
                        <v-tab class="">
                          <div>
                            <img src="/static/img/mobile.svg" />
                            {{ $t("mobile") }}
                          </div>
                        </v-tab>
                      </v-tabs>
                    </v-container>
                    <v-tabs-items v-model="selectedTab">
                      <v-tab-item>
                        <v-container>
                          <div class="pdf-view">
                            <div
                              class="pdf-content sub_title"
                              v-html="
                                newsLetter.subjectLine[language.shortForm]
                              "
                            ></div>
                            <div
                              v-if="newsLetter.image"
                              class="pdf-content newsletter-image-warp"
                            >
                              <img
                                :src="`/files/images/${newsLetter.image}`"
                                alt="Newsletter Image"
                                class="newsletter-image"
                              />
                            </div>
                            <div
                              class="pdf-content newsletter-image-warp"
                              v-html="newsLetter.body[language.shortForm]"
                            ></div>

                            <div
                              v-if="language.shortForm === 'EN'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div>
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Imprint</b><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Germany</span><br />
                                  <br />
                                  <span>Telephone: +49 89 3547-0</span><br />
                                  <span>Fax: +49 89 3547-2767</span><br />
                                  <span
                                    >Email:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >CEO: Mario Beinert, Dr.Peter Radina, Harald
                                    Schneider, Cora Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Chairman of the Supervisory Board:
                                    Dr.Nicolas Lange</span
                                  ><br />
                                  <span>Munich Local Court</span><br />
                                  <span>Register Court Munich: HRB 91181</span
                                  ><br />
                                  <span
                                    >Registered office of the company: Munich </span
                                  ><br />
                                  <span>VAT ID No.: DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Privacy Policy</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Don't want to stay up to date with
                                  Knorr-Bremse RailServices Training Academy?<br />
                                  You can always
                                  <a href="#" style="text-decoration: none"
                                    >Unsubscribe here</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'DE'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Impressum</b><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Deutschland</span><br />
                                  <br />
                                  <span>Telephone: +49 89 3547-0</span><br />
                                  <span>Fax: +49 89 3547-2767</span><br />
                                  <span
                                    >Email:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Geschäftsführer: Mario Beinert, Dr.Peter
                                    Radina, Harald Schneider, Cora
                                    Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Vorsitzender des Aufsichtsrates: Dr.Nicolas
                                    Lange</span
                                  ><br />
                                  <span>Amtsgericht München</span><br />
                                  <span>Registergericht München: HRB 91181</span
                                  ><br />
                                  <span>Sitz der Gesellschaft: München </span
                                  ><br />
                                  <span>USt.-IdNr.: DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_de.pdf"
                                    >Datenschutzerklärung</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Sie wollen nicht auf dem Laufenden bleiben mit
                                  der Knorr-Bremse RailServices Training
                                  Academy?<br />
                                  Sie können jederzeit
                                  <a href="#" style="text-decoration: none"
                                    >Hier abbestellen</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'PL'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Impressum</b><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Niemcy</span><br />
                                  <br />
                                  <span>telefon: +49 89 3547-0</span><br />
                                  <span>faks: +49 89 3547-2767</span><br />
                                  <span
                                    >e-mail:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Zarząd: Mario Beinert, dr.Peter Radina,
                                    Harald Schneider, Cora Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Przewodniczący Rady Nadzorczej: Dr.Nicolas
                                    Lange</span
                                  ><br />
                                  <span>Sąd Rejonowy w Monachium</span><br />
                                  <span
                                    >Sąd Rejestrowy w Monachium: HRB 91181</span
                                  ><br />
                                  <span>Siedziba firmy: Monachium </span><br />
                                  <span>NIP: DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_de.pdf"
                                    >Polityka prywatności</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Don't want to stay up to date with
                                  Knorr-Bremse RailServices Training Academy?<br />
                                  Zawsze możesz
                                  <a href="#" style="text-decoration: none"
                                    >Zrezygnuj z subskrypcji tutaj</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'FR'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Mentions légales</b
                                  ><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Allemagne</span><br />
                                  <br />
                                  <span>Téléphone: +49 89 3547-0</span><br />
                                  <span>Fax: +49 89 3547-2767</span><br />
                                  <span
                                    >Email:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >PDG : Mario Beinert, Dr.Peter Radina,
                                    Harald Schneider, Cora Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Président du Comité de Surveillance :
                                    Nicolas Lange</span
                                  ><br />
                                  <span>Tribunal administratif de Munich</span
                                  ><br />
                                  <span
                                    >Numéro d’immatriculation au registre du
                                    commerce de Munich : HRB 91181</span
                                  ><br />
                                  <span
                                    >Siège social de la société : Munich </span
                                  ><br />
                                  <span>N° de TVA : DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Politique de protection des données</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Vous ne souhaitez pas rester à jour avec
                                  Knorr-Bremse RailServices Training Academy
                                  ?<br />
                                  Vous pouvez toujours
                                  <a href="#" style="text-decoration: none"
                                    >Se désabonner ici</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'HU'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Impresszum</b><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Németország</span><br />
                                  <br />
                                  <span>Telefon: +49 89 3547-0</span><br />
                                  <span>Fax: +49 89 3547-2767</span><br />
                                  <span
                                    >Email:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Elnökök: Mario Beinert, Dr.Peter Radina,
                                    Harald Schneider, Cora Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Felügyelőbizottság elnöke: Dr.Nicolas
                                    Lange</span
                                  ><br />
                                  <span>Müncheni Járásbíróság</span><br />
                                  <span>Müncheni Cégbíróság: HRB 91181</span
                                  ><br />
                                  <span>A társaság székhelye: München </span
                                  ><br />
                                  <span>Adószám: DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Adatvédelmi nyilatkozat</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Nem szeretne naprakész maradni a Knorr-Bremse
                                  RailServices Training Academy-vel
                                  kapcsolatban?<br />
                                  Bármikor
                                  <a href="#" style="text-decoration: none"
                                    >Leiratkozás itt</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'RU'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Выходные данные</b
                                  ><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Deutschland (Германия)</span><br />
                                  <br />
                                  <span>Телефон: +49 89 3547-0</span><br />
                                  <span>Факс: +49 89 3547-2767</span><br />
                                  <span
                                    >Электронная почта:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Руководство:Марио Байнерт (Mario Beinert),
                                    д-р Петер Родина (Dr. Peter Radina), Харальд
                                    Шнайдер (Harald Schneider), Кора
                                    Хентрих-Хенне (Cora Hentrich-Henne)</span
                                  ><br />
                                  <br />
                                  <span
                                    >Председатель Наблюдательного совета:д-р
                                    Николас Ланге (Dr. Nicolas Lange)</span
                                  ><br />
                                  <span>Участковый суд Мюнхена</span><br />
                                  <span
                                    >Отдел торгового реестра Мюнхена: HRB
                                    91181</span
                                  ><br />
                                  <span
                                    >RМестонахождение компании: г. Мюнхен </span
                                  ><br />
                                  <span
                                    >Идентификационный номер плательщика НДС:
                                    DE129395680</span
                                  ><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Политика конфиденциальности</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Не хотите быть в курсе последних событий,
                                  связанных с Учебной академией Knorr-Bremse
                                  RailServices?<br />
                                  Вы всегда можете
                                  <a href="#" style="text-decoration: none"
                                    >Отписаться здесь</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'KK'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000"
                                    >Компания бойынша мәліметтер</b
                                  ><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Берлин</span><br />
                                  <span>Германия</span><br />
                                  <br />
                                  <span>Телефон: +49 89 3547-0</span><br />
                                  <span>Факс: +49 89 3547-2767</span><br />
                                  <span
                                    >Электрондық пошта:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Бас атқарушы директор: Mario Beinert,
                                    Dr.Peter Radina, Harald Schneider, Cora
                                    Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Бақылау кеңесінің төрағасы: Dr.Nicolas
                                    Lange</span
                                  ><br />
                                  <span>Мюнхен қаласының жергілікті соты</span
                                  ><br />
                                  <span
                                    >Мюнхен қаласының тіркеу соты: HRB
                                    91181</span
                                  ><br />
                                  <span
                                    >Компанияның тіркелген мекені: Мюнхен </span
                                  ><br />
                                  <span
                                    >ҚҚС төлеушінің жеке нөмірі:
                                    DE129395680</span
                                  ><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Дербес деректерді қорғау бойынша
                                    мәлімдеме</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Knorr-Bremse RailServices Training Academy
                                  туралы хабардар болғыңыз келмей ме?<br />
                                  Сіз әрқашан аласыз
                                  <a href="#" style="text-decoration: none"
                                    >Мұнда жазылудан бас тартыңыз</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'ES'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Aviso legal</b
                                  ><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Alemania</span><br />
                                  <br />
                                  <span>Telephone: +49 89 3547-0</span><br />
                                  <span>Fax: +49 89 3547-2767</span><br />
                                  <span
                                    >Correo electrónico:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Director ejecutivo: Mario Beinert, Dr.Peter
                                    Radina, Harald Schneider, Cora
                                    Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Presidente del Consejo de Supervisión:
                                    Dr.Nicolas Lange</span
                                  ><br />
                                  <span>Tribunal Local de Múnich</span><br />
                                  <span
                                    >Tribunal de Registro de Múnich: HRB
                                    91181</span
                                  ><br />
                                  <span
                                    >Domicilio social de la empresa: Múnich </span
                                  ><br />
                                  <span
                                    >Número de identificación fiscal:
                                    DE129395680</span
                                  ><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Política de privacidad</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  ¿No quieres mantenerte al día con la Academia
                                  de formación RailServices de Knorr-Bremse?<br />
                                  Siempre puedes
                                  <a href="#" style="text-decoration: none"
                                    >Darse de baja aquí</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'IT'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Imprint</b><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Germany</span><br />
                                  <br />
                                  <span>Telephone: +49 89 3547-0</span><br />
                                  <span>Fax: +49 89 3547-2767</span><br />
                                  <span
                                    >Email:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Amministratore delegato: Mario Beinert,
                                    Dr.Peter Radina, Harald Schneider, Cora
                                    Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Presidente del consiglio di vigilanza:
                                    Dr.Nicolas Lange</span
                                  ><br />
                                  <span>Pretura di Monaco</span><br />
                                  <span
                                    >Registro delle imprese del tribunale di
                                    Monaco: HRB 91181</span
                                  ><br />
                                  <span
                                    >Sede legale della società: Monaco di
                                    Baviera</span
                                  ><br />
                                  <span>P.IVA: DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Informativa sulla privacy</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Non volete essere aggiornati sulla
                                  Knorr-Bremse RailServices Training Academy?<br />
                                  Si può sempre
                                  <a href="#" style="text-decoration: none"
                                    >Annullamento dell'iscrizione qui</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'ZH'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">版权</b><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Germany</span><br />
                                  <br />
                                  <span>电话: +49 89 3547-0</span><br />
                                  <span>传真: +49 89 3547-2767</span><br />
                                  <span
                                    >邮箱:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >首席执行官: Mario Beinert, Peter Radina
                                    博士, Harald Schneider, Cora
                                    Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span>监事会主席: Nicolas Lange 博士</span
                                  ><br />
                                  <span>慕尼黑地方法院</span><br />
                                  <span>慕尼黑注册法院: HRB 91181</span><br />
                                  <span>公司注册地：慕尼黑</span><br />
                                  <span>增值税号: DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_zh.pdf"
                                    >隐私政策</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  不想及时了解 克诺尔集团铁路服务培训
                                  学院的最新信息？<br />
                                  您可以随时
                                  <a href="#" style="text-decoration: none"
                                    >在此退订</a
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </v-container>
                      </v-tab-item>
                      <v-tab-item>
                        <v-container>
                          <div class="pdf-view mob_view">
                            <div
                              class="pdf-content sub_title"
                              v-html="
                                newsLetter.subjectLine[language.shortForm]
                              "
                            ></div>
                            <div
                              v-if="newsLetter.image"
                              class="pdf-content newsletter-image-warp"
                            >
                              <img
                                :src="`/files/images/${newsLetter.image}`"
                                alt="Newsletter Image"
                                class="newsletter-image"
                              />
                            </div>
                            <div
                              class="pdf-content newsletter-image-warp"
                              v-html="newsLetter.body[language.shortForm]"
                            ></div>

                            <div
                              v-if="language.shortForm === 'EN'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div>
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Imprint</b><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Germany</span><br />
                                  <br />
                                  <span>Telephone: +49 89 3547-0</span><br />
                                  <span>Fax: +49 89 3547-2767</span><br />
                                  <span
                                    >Email:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >CEO: Mario Beinert, Dr.Peter Radina, Harald
                                    Schneider, Cora Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Chairman of the Supervisory Board:
                                    Dr.Nicolas Lange</span
                                  ><br />
                                  <span>Munich Local Court</span><br />
                                  <span>Register Court Munich: HRB 91181</span
                                  ><br />
                                  <span
                                    >Registered office of the company: Munich </span
                                  ><br />
                                  <span>VAT ID No.: DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Privacy Policy</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Don't want to stay up to date with
                                  Knorr-Bremse RailServices Training Academy?<br />
                                  You can always
                                  <a href="#" style="text-decoration: none"
                                    >Unsubscribe here</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'DE'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Impressum</b><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Deutschland</span><br />
                                  <br />
                                  <span>Telephone: +49 89 3547-0</span><br />
                                  <span>Fax: +49 89 3547-2767</span><br />
                                  <span
                                    >Email:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Geschäftsführer: Mario Beinert, Dr.Peter
                                    Radina, Harald Schneider, Cora
                                    Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Vorsitzender des Aufsichtsrates: Dr.Nicolas
                                    Lange</span
                                  ><br />
                                  <span>Amtsgericht München</span><br />
                                  <span>Registergericht München: HRB 91181</span
                                  ><br />
                                  <span>Sitz der Gesellschaft: München </span
                                  ><br />
                                  <span>USt.-IdNr.: DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_de.pdf"
                                    >Datenschutzerklärung</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Sie wollen nicht auf dem Laufenden bleiben mit
                                  der Knorr-Bremse RailServices Training
                                  Academy?<br />
                                  Sie können jederzeit
                                  <a href="#" style="text-decoration: none"
                                    >Hier abbestellen</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'PL'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Impressum</b><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Niemcy</span><br />
                                  <br />
                                  <span>telefon: +49 89 3547-0</span><br />
                                  <span>faks: +49 89 3547-2767</span><br />
                                  <span
                                    >e-mail:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Zarząd: Mario Beinert, dr.Peter Radina,
                                    Harald Schneider, Cora Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Przewodniczący Rady Nadzorczej: Dr.Nicolas
                                    Lange</span
                                  ><br />
                                  <span>Sąd Rejonowy w Monachium</span><br />
                                  <span
                                    >Sąd Rejestrowy w Monachium: HRB 91181</span
                                  ><br />
                                  <span>Siedziba firmy: Monachium </span><br />
                                  <span>NIP: DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_de.pdf"
                                    >Polityka prywatności</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Don't want to stay up to date with
                                  Knorr-Bremse RailServices Training Academy?<br />
                                  Zawsze możesz
                                  <a href="#" style="text-decoration: none"
                                    >Zrezygnuj z subskrypcji tutaj</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'FR'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Mentions légales</b
                                  ><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Allemagne</span><br />
                                  <br />
                                  <span>Téléphone: +49 89 3547-0</span><br />
                                  <span>Fax: +49 89 3547-2767</span><br />
                                  <span
                                    >Email:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >PDG : Mario Beinert, Dr.Peter Radina,
                                    Harald Schneider, Cora Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Président du Comité de Surveillance :
                                    Nicolas Lange</span
                                  ><br />
                                  <span>Tribunal administratif de Munich</span
                                  ><br />
                                  <span
                                    >Numéro d’immatriculation au registre du
                                    commerce de Munich : HRB 91181</span
                                  ><br />
                                  <span
                                    >Siège social de la société : Munich </span
                                  ><br />
                                  <span>N° de TVA : DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Politique de protection des données</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Vous ne souhaitez pas rester à jour avec
                                  Knorr-Bremse RailServices Training Academy
                                  ?<br />
                                  Vous pouvez toujours
                                  <a href="#" style="text-decoration: none"
                                    >Se désabonner ici</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'HU'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Impresszum</b><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Németország</span><br />
                                  <br />
                                  <span>Telefon: +49 89 3547-0</span><br />
                                  <span>Fax: +49 89 3547-2767</span><br />
                                  <span
                                    >Email:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Elnökök: Mario Beinert, Dr.Peter Radina,
                                    Harald Schneider, Cora Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Felügyelőbizottság elnöke: Dr.Nicolas
                                    Lange</span
                                  ><br />
                                  <span>Müncheni Járásbíróság</span><br />
                                  <span>Müncheni Cégbíróság: HRB 91181</span
                                  ><br />
                                  <span>A társaság székhelye: München </span
                                  ><br />
                                  <span>Adószám: DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Adatvédelmi nyilatkozat</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Nem szeretne naprakész maradni a Knorr-Bremse
                                  RailServices Training Academy-vel
                                  kapcsolatban?<br />
                                  Bármikor
                                  <a href="#" style="text-decoration: none"
                                    >Leiratkozás itt</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'RU'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Выходные данные</b
                                  ><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Deutschland (Германия)</span><br />
                                  <br />
                                  <span>Телефон: +49 89 3547-0</span><br />
                                  <span>Факс: +49 89 3547-2767</span><br />
                                  <span
                                    >Электронная почта:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Руководство:Марио Байнерт (Mario Beinert),
                                    д-р Петер Родина (Dr. Peter Radina), Харальд
                                    Шнайдер (Harald Schneider), Кора
                                    Хентрих-Хенне (Cora Hentrich-Henne)</span
                                  ><br />
                                  <br />
                                  <span
                                    >Председатель Наблюдательного совета:д-р
                                    Николас Ланге (Dr. Nicolas Lange)</span
                                  ><br />
                                  <span>Участковый суд Мюнхена</span><br />
                                  <span
                                    >Отдел торгового реестра Мюнхена: HRB
                                    91181</span
                                  ><br />
                                  <span
                                    >RМестонахождение компании: г. Мюнхен </span
                                  ><br />
                                  <span
                                    >Идентификационный номер плательщика НДС:
                                    DE129395680</span
                                  ><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Политика конфиденциальности</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Не хотите быть в курсе последних событий,
                                  связанных с Учебной академией Knorr-Bremse
                                  RailServices?<br />
                                  Вы всегда можете
                                  <a href="#" style="text-decoration: none"
                                    >Отписаться здесь</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'KK'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000"
                                    >Компания бойынша мәліметтер</b
                                  ><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Берлин</span><br />
                                  <span>Германия</span><br />
                                  <br />
                                  <span>Телефон: +49 89 3547-0</span><br />
                                  <span>Факс: +49 89 3547-2767</span><br />
                                  <span
                                    >Электрондық пошта:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Бас атқарушы директор: Mario Beinert,
                                    Dr.Peter Radina, Harald Schneider, Cora
                                    Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Бақылау кеңесінің төрағасы: Dr.Nicolas
                                    Lange</span
                                  ><br />
                                  <span>Мюнхен қаласының жергілікті соты</span
                                  ><br />
                                  <span
                                    >Мюнхен қаласының тіркеу соты: HRB
                                    91181</span
                                  ><br />
                                  <span
                                    >Компанияның тіркелген мекені: Мюнхен </span
                                  ><br />
                                  <span
                                    >ҚҚС төлеушінің жеке нөмірі:
                                    DE129395680</span
                                  ><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Дербес деректерді қорғау бойынша
                                    мәлімдеме</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Knorr-Bremse RailServices Training Academy
                                  туралы хабардар болғыңыз келмей ме?<br />
                                  Сіз әрқашан аласыз
                                  <a href="#" style="text-decoration: none"
                                    >Мұнда жазылудан бас тартыңыз</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'ES'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Aviso legal</b
                                  ><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Alemania</span><br />
                                  <br />
                                  <span>Telephone: +49 89 3547-0</span><br />
                                  <span>Fax: +49 89 3547-2767</span><br />
                                  <span
                                    >Correo electrónico:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Director ejecutivo: Mario Beinert, Dr.Peter
                                    Radina, Harald Schneider, Cora
                                    Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Presidente del Consejo de Supervisión:
                                    Dr.Nicolas Lange</span
                                  ><br />
                                  <span>Tribunal Local de Múnich</span><br />
                                  <span
                                    >Tribunal de Registro de Múnich: HRB
                                    91181</span
                                  ><br />
                                  <span
                                    >Domicilio social de la empresa: Múnich </span
                                  ><br />
                                  <span
                                    >Número de identificación fiscal:
                                    DE129395680</span
                                  ><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Política de privacidad</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  ¿No quieres mantenerte al día con la Academia
                                  de formación RailServices de Knorr-Bremse?<br />
                                  Siempre puedes
                                  <a href="#" style="text-decoration: none"
                                    >Darse de baja aquí</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'IT'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">Imprint</b><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Germany</span><br />
                                  <br />
                                  <span>Telephone: +49 89 3547-0</span><br />
                                  <span>Fax: +49 89 3547-2767</span><br />
                                  <span
                                    >Email:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >Amministratore delegato: Mario Beinert,
                                    Dr.Peter Radina, Harald Schneider, Cora
                                    Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span
                                    >Presidente del consiglio di vigilanza:
                                    Dr.Nicolas Lange</span
                                  ><br />
                                  <span>Pretura di Monaco</span><br />
                                  <span
                                    >Registro delle imprese del tribunale di
                                    Monaco: HRB 91181</span
                                  ><br />
                                  <span
                                    >Sede legale della società: Monaco di
                                    Baviera</span
                                  ><br />
                                  <span>P.IVA: DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >Informativa sulla privacy</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  Non volete essere aggiornati sulla
                                  Knorr-Bremse RailServices Training Academy?<br />
                                  Si può sempre
                                  <a href="#" style="text-decoration: none"
                                    >Annullamento dell'iscrizione qui</a
                                  >
                                </p>
                              </div>
                            </div>

                            <div
                              v-if="language.shortForm === 'ZH'"
                              class="pdf-content newsletter-image-warp"
                              style="margin-top: 30px; line-height: 1.5"
                            >
                              <div
                                class="content-1"
                                style="
                                  padding-top: 30px;
                                  margin-top: 30px;
                                  border-top: 1px solid #d9d9d9;
                                "
                              >
                                <p style="margin: 0px; line-height: 1.5">
                                  <b style="color: #000000">版权</b><br />

                                  <span
                                    >Knorr-Bremse Systeme für Schienenfahrzeuge
                                    GmbH</span
                                  ><br />
                                  <span>Georg-Knorr Straße 4</span><br />
                                  <span>12681 Berlin</span><br />
                                  <span>Germany</span><br />
                                  <br />
                                  <span>电话: +49 89 3547-0</span><br />
                                  <span>传真: +49 89 3547-2767</span><br />
                                  <span
                                    >邮箱:
                                    <a
                                      class="font-grey"
                                      href="mailto:info@knorr-bremse.com"
                                      >info@knorr-bremse.com</a
                                    ></span
                                  ><br />
                                  <br />
                                  <span
                                    >首席执行官: Mario Beinert, Peter Radina
                                    博士, Harald Schneider, Cora
                                    Hentrich-Henne</span
                                  ><br />
                                  <br />
                                  <span>监事会主席：Nicolas Lange 博士</span
                                  ><br />
                                  <span>慕尼黑地方法院</span><br />
                                  <span>慕尼黑注册法院: HRB 91181</span><br />
                                  <span>公司注册地：慕尼黑 </span><br />
                                  <span>增值税号: DE129395680</span><br />

                                  <a
                                    href="https://training-railservices.knorr-bremse.com/files/images/KB_DS-Hinweise_Customer_Training_Portal_en.pdf"
                                    >隐私政策</a
                                  >
                                </p>
                                <p style="padding-top: 30px">
                                  不想了解克诺尔制动系统有限公司培训学院的最新信息？<br />
                                  您可以随时
                                  <a href="#" style="text-decoration: none"
                                    >在此退订</a
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </v-container>
                      </v-tab-item>
                    </v-tabs-items>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </div>
          <div
            class="col-xl-3 padding-30 pr-0 pt-0 d-flex flex-column nl_right_colum"
          >
            <div class="newsletter_bg padding-30">
              <p class="nl_head_title">{{ $t("send_to") }}</p>

              <v-select
                hide-details="auto"
                dense
                outlined
                class="datainput mb-2 mt-2"
                :items="audiences"
                :label="$t('select_subscribers_group') + '*'"
                :item-text="
                  (item) => `${item.designation} (${item.subscriptionCount})`
                "
                item-value="id"
                multiple
                v-model="newsLetter.audienceId"
              ></v-select>

              {{ $t("totalSubscription") }} {{ totalSubscriptionCount }}
              {{ $t("Subscribers") }}
            </div>

            <div class="newsletter_bg padding-30">
              <p class="mb-3 nl_head_title">{{ $t("newsLetter_subject") }}</p>
              <p class="subject_preview_break">{{ newsLetter.subjectLine[languageCode] }}</p>
            </div>

            <div class="newsletter_bg padding-30">
              <p class="mb-4 nl_head_title">{{ $t("form_title") }}</p>
              <!--<p class="mb-4">{{$t("from_Name_And_Email")}}</p>-->
              <p>
                <strong>{{ $t("rail_Services") }}</strong>
              </p>
              <p>{{ $t("mail") }}</p>
            </div>

            <div class="">
              <div class="col-md-12 p-0 d-flex g-space-15 viewer_btn pnl">
                <v-btn
                  @click="edit()"
                  outlined
                  depressed
                  tile
                  class="cancelBtn"
                >
                  <img src="/static/img/pen.svg" />
                  {{ $t("edit") }}</v-btn
                >
                <v-btn
                  @click="testEmailCall()"
                  outlined
                  depressed
                  tile
                  class="savebutton"
                >
                  <img src="/static/img/arrow.svg" width="18" />
                  {{ $t("test_mail_text") }}</v-btn
                >
                <v-btn
                  outlined
                  depressed
                  tile
                  class="savebutton"
                  @click="publishEmailCall()"
                >
                  <img src="/static/img/env.svg" width="18" />
                  {{ $t("publish_newsletter") }}</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="dialogConfirmation" content-class="dng_popup ste_popup">
      <img
        class="nl_close"
        @click="clearDataOnSecondDialogue"
        src="/static/img/newsletter_close.svg"
      />
      <img
        class="newsletter_v_arrow"
        src="/static/img/newsletter_v_arrow.svg"
      />
      <h3 class="align_center">{{ $t("send_Test_Mail") }}</h3>
      <p class="mb-5">{{ $t("send_Test_To") }}</p>
      <v-text-field
        hide-details="auto"
        class="datainput justify-content-end align-self-center pb-1 sto_newsletter_select_first"
        dense
        outlined
        :label="$t('enter_your_mail')"
        v-model="testEmail.testEmail"
      ></v-text-field>
      <v-card-actions class="align_center g-space-15">
        <v-btn
          @click="confirmTestEmail()"
          outlined
          depressed
          tile
          class="savebutton"
        >
          {{ $t("test_mail_text") }}</v-btn
        >
        <v-btn
          @click="clearDataOnSecondDialogue()"
          class="close_btn_link mr-2 mb-2"
        >
          {{ $t("cancel") }}</v-btn
        >
      </v-card-actions>
    </v-dialog>

    <v-dialog v-model="testdialog" content-class="dng_popup ste_popup">
      <!-- <img class="nl_close" @click="closeDialogTest()" /> -->
      <img
        class="newsletter_v_arrow"
        src="/static/img/sub_bluetick.svg"
        alt="arraow"
      />
      <h3 class="align_center">{{ $t("test_mail_sent_successfully") }}</h3>
      <p class="mb-6 mt-5" style="width: 100%">
        {{ $t("test_mail_sent_message", { email: testEmailLabel }) }}
      </p>
      <a @click="closeDialogTest()" class="close_btn_link">{{
        $t("close")
      }}</a>
    </v-dialog>

    <v-dialog
      v-model="dialogPublishConfirmation"
      content-class="dng_popup ste_popup text-align-center"
    >
      <!-- <img class="nl_close" @click="clearDataOnSecondDialoguePublish()" /> -->
      <img
        class="newsletter_v_arrow"
        src="/static/img/publish.svg"
        style="width: 50px; height: 50px; margin-bottom: 20px"
        alt="publish"
      />
      <h3
        class="align_center"
        style="font-size: 22px; font-weight: 700; color: #000"
      >
        {{ $t("confirm_newsletter_send") }}
      </h3>
      <p class="mb-4">{{ $t("send_review") }}</p>
      <p class="mb-4">{{ $t("the_action_cannot_be_undone") }}</p>
      <v-card-actions class="align_center g-space-15">
        <v-btn
          @click="confirmPublishEmail()"
          outlined
          depressed
          tile
          class="savebutton mr-0 mb-0"
        >
          {{ $t("confirm_send") }}</v-btn
        >
        <v-btn
          @click="clearDataOnSecondDialoguePublish()"
          class="close_btn_link mr-0 mb-0"
        >
          {{ $t("cancel") }}</v-btn
        >
      </v-card-actions>
    </v-dialog>

    <v-dialog
      v-model="dialogDashBoard"
      content-class="dng_popup text-align-center"
    >
      <img
        class="newsletter_v_arrow"
        src="/static/img/sub_bluetick.svg"
        style="width: 50px; height: 50px; margin-bottom: 20px"
      />
      <h3
        class="align_center"
        style="font-size: 22px; font-weight: 700; color: #000"
      >
        {{ $t("newsletter_sent") }}
      </h3>
      <p class="mb-4">{{ $t("newsletter_delivered") }}</p>
      <a @click="manageNewsLetter()" class="close_btn_link">{{ $t("go_to_dashboard") }}</a>
    </v-dialog>
  </div>
</template>
<script>
import Card from "./custom/Card.vue";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Card,
    Breadcrumb,
  },
  data() {
    return {
      audiences: null,
      totalSubscriptionCount: 0,
      languageTab: null,

      selectedTab: 0,
      newsLetter: {
        id: null,
        subjectLine: {},
        image: null,
        body: {},
        audienceId: [],
      },
      testEmail: {
        testEmail: null,
      },
      dialogConfirmation: false,
      dialogPublishConfirmation: false,
      dialogDashBoard: false,
      testdialog: false,
      testEmailLabel: null,
      // languageCode: this.languageTabsNew[0].shortForm,
    };
  },
  computed: {
    // languageCode() {
    //   const map = {
    //     0: "EN",
    //     1: "DE",
    //     2: "PL",
    //     3: "FR",
    //     4: "IT",
    //     5: "ES",
    //     6: "HU",
    //     7: "RU",
    //     8: "KK",
    //     9: "ZH",
    //   };
    //   return map[this.languageTab] || "EN"; // fallback to EN
    // },
    languageTabsNew() {
      if (this.$root.languageTabsNew) {
        this.languageCode = this.$root.languageTabsNew[0].shortForm;
      }
      return this.$root.languageTabsNew;
    },
    possiblelanguagesComputed() {
      return this.$root.languageTabsNew.map((language) => ({
        name: language.translatedName,
        flag: language.flag,
        shortForm: language.shortForm,
        value: language.language,
      }));
    },
  },
  mounted() {
    var _this = this;

    if (
      this.isLoad != true &&
      !window.location.href.includes("?") &&
      !window.location.href.includes("?lang=")
    ) {
      this.isLoad = true;
      window.location.href =
        window.location.href + "?lang=" + this.$locale.toUpperCase();
    }else if (
      this.isLoad != true &&
      !window.location.href.includes("&lang=")
    ) {
      window.location.href =
        window.location.href + "&lang=" + this.$locale.toUpperCase();
    }

    if (this.$route.query.newsLetterId) {
      this.$axios
        .get(
          "/api/newsletter/newsletter/" +
            parseInt(this.$route.query.newsLetterId)
        )
        .then(function (response) {
          _this.newsLetter = response.data;
          _this.newsLetter.subjectLine = _this.newsLetter.subjectMap;
          _this.lowerCaseMapKeys(_this.newsLetter.subjectLine);
          _this.newsLetter.body = _this.newsLetter.bodyMap;
          _this.lowerCaseMapKeys(_this.newsLetter.body);
          _this.fetchAllAudience();
        });
    }
  },
  methods: {
    getLanguuageCode(shortform) {
      this.languageCode = shortform;
    },
    manageNewsLetter() {
      this.$router.push({
        path: "/manage-newsletter",
        query: { selectedTab: 1 },
      });
    },
    closeDialogTest() {
      this.testdialog = false;
    },
    fetchAllAudience() {
      var _this = this;
      this.$axios
        .get("/api/newsletter/get-newsletter-audience")
        .then(function (response) {
          _this.audiences = response.data;
          let totalSubscriptionCount = 0;

          _this.newsLetter.audienceId.forEach((audienceId) => {
            const matchedAudience = _this.audiences.find(
              (a) => a.id === audienceId
            );
            if (matchedAudience) {
              totalSubscriptionCount += matchedAudience.subscriptionCount;
            }
          });
          _this.totalSubscriptionCount = totalSubscriptionCount;
        })
        .catch(this.onError);
    },
    lowerCaseMapKeys(map) {
      for (var key in map) {
        if (map.hasOwnProperty(key)) {
          if (key == key.toUpperCase()) continue;
          map[key.toUpperCase()] = map[key];
          delete map[key];
        }
      }
    },
    onFinally() {
      showLoadingCircle(false);
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    edit() {
      this.$router.push("/edit-news-letter?newsLetterId=" + this.newsLetter.id);
    },
    testEmailCall() {
      this.dialogConfirmation = true;
    },
    publishEmailCall() {
      this.dialogPublishConfirmation = true;
    },
    confirmPublishEmail() {
      var _this = this;

      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .post(
          "api/newsletter/publishemail/" +
            parseInt(this.$route.query.newsLetterId),
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          _this.dialogPublishConfirmation = false;
          _this.dialogDashBoard = true;
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    confirmTestEmail() {
      var _this = this;
      let testEmail = _this.testEmail;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.$isStringEmptyOrNull(testEmail.testEmail)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("email") }));
        return;
      } else if (!emailRegex.test(testEmail.testEmail)) {
        this.$noty.error(this.$t("invalid_value", { name: this.$t("email") }));
        return;
      }
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .post(
          "api/newsletter/testemail/" +
            parseInt(this.$route.query.newsLetterId),
          testEmail,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          _this.testEmailLabel = _this.testEmail.testEmail;
          _this.testEmail.testEmail = null;
          _this.dialogConfirmation = false;
          _this.testdialog = true;
          _this.$forceUpdate();
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    clearDataOnSecondDialogue() {
      this.dialogConfirmation = false;
      this.$forceUpdate();
    },
    clearDataOnSecondDialoguePublish() {
      this.dialogPublishConfirmation = false;
      this.$forceUpdate();
    },
  },
};

function limitDraggedImageWidth() {
  const images = document.querySelectorAll('.pdf-view .newsletter-image-warp img');
  images.forEach(img => {
    const inlineWidth = img.style.width;

    if (inlineWidth) {
      // Extract width value (e.g., "800px" → 800)
      const numericWidth = parseInt(inlineWidth.replace('px', ''), 10);
      if (numericWidth > 600) {
        img.style.width = '600px';
      }
    }
  });
}

// Optional: call this when user makes changes
// or watch the DOM:
const editor = document.querySelector('.pdf-view');
if (editor) {
  const observer = new MutationObserver(() => {
    limitDraggedImageWidth();
  });

  observer.observe(editor, { childList: true, subtree: true });
}
</script>
